import styled from 'styled-components';

import Alert from '@r1-frontend/ui-react/components/Alert';
import { AlertIcon } from '@r1-frontend/ui-react/components/Alert/styled';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import PopupResult from '@r1-frontend/ui-react/components/popups/popupResult';
import { Text } from '@r1-frontend/ui-react/components/popups/popupResult/styled';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';

export const CookieAlert = styled.div`
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translate(-50%);
    width: max-content;
    z-index: 999;
`;

export const StyledAlert = styled(Alert)`    
    @media (max-width: ${wideBreakpoints.mobile}) {
        display: block;
    }

    ${AlertIcon} {
        width: auto;
        height: auto;
        align-self: center;
    }

    ${IndentContainer} {
        margin-left: 24px;

        @media (max-width: ${wideBreakpoints.mobile}) {
            padding-top: 10px;
            margin-left: 0;
            width: 100%;
        }
    }
`;

export const SPopupResult = styled(PopupResult)`
    ${Text} {
        margin-top: 0;
    }
`;
